import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Field from '~/components/form-controls/Field';
import RadioGroup, {
  ButtonOption,
} from '~/components/form-controls/RadioGroup';
import Page from '~/components/layout/page/Page';
import { useActionResult, useLoaderData } from './shippingClaimReason';

export default function ShippingClaimReasonPage() {
  const { reasons, selectedReason } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Root title="What happened?">
      <Form>
        <RadioGroup label="Reorder reasons" showLabel={false}>
          {reasons.map(({ value, label }) => (
            <ButtonOption
              key={value}
              value={value}
              name="reason"
              required
              defaultChecked={value === selectedReason}
            >
              {label}
            </ButtonOption>
          ))}
        </RadioGroup>

        {actionResult?.ok === false && (
          <Field.ErrorText>{actionResult.message}</Field.ErrorText>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Root>
  );
}
